import { colors, fonts } from '@grupoboticario/flora-tokens/oui/web/ds'

export const oui = {
  colors,
  fonts,
}
